import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/blogs/BlogCardView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Navbar.tsx");
